// assets
import { IconDeviceDesktop } from "@tabler/icons";

// constant
const icons = {
  IconDeviceDesktop,
};

// ==============================|| TERMINALES MENU ITEMS ||============================== //

const terminales = {
  id: "Terminales",
  title: "",
  type: "group",
  children: [
    {
      id: "Terminales",
      title: "Terminales",
      type: "item",
      url: "/terminales/terminales-list",
      icon: icons.IconDeviceDesktop,
      breadcrumbs: false,
    },
  ],
};

export default terminales;
